export default "__VITE_ASSET__D6k21jIQ__"